import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Button,
  IconButton,
  Typography,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Dashbard from "../../Dashbard";
import Loader from "../../../../../components/common/Loader";
import GridSearchFilter, {
  AutoComplete,
  FilterAutoComplete,
  SelectedChiptItems,
  SelectedDateChip,
} from "../../../../../components/common/FilterLayout/GridFilter";
import ProspectGenerationGrid from "./ProspectGenerationGrid";
import { useDebounce } from "../../../../../utils/use-debounce";
import { InputField, Pagination } from "../../../../../components/common";
import { useDispatch, useSelector } from "react-redux";
import { contactsTypesActions } from "../../../../../store/contactTypes/contactTypesActions";
import { ExpandMore, MoreHoriz } from "@material-ui/icons";
import { ChipItem } from "../../Conversations/ConverstionSettings/GridFilter";
import { FilterCreationDate } from "../../EndUser";
import moment from "moment";
import {
  ConversationConfig,
  endpoints,
} from "../../../../../config/conversationConfig";
import * as signalR from "@microsoft/signalr";
import { conversationAction } from "../../../../../store/conversations/conversationAction";
import AddProspectModal from "./AddProspectModal";
import { toast } from "react-toastify";
import { dashboardActions } from "../../../../../store/dashboard/dashboardActions";

const ProspectGeneration = () => {
  // const outToken = localStorage.getItem("backend_api_token");
  const { hubId } = useSelector(state => state.conversationReducer);
  const { isOutlookLogin } = useSelector(state => state.dashboardReducer);
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const history = useHistory();
  const dispatch = useDispatch();
  let filtersIndex = 0;
  const filtersLimit = 4;
  const indexReference = useRef(filtersIndex);
  const selectedRoomRef = useRef(null);
  const { connectionUrl } = endpoints.conversation;
  const [connection, setConnection] = useState(null);
  const [roomMsgs, setRoomMsgs] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [leadData, setLeadData] = useState(null);

  const [isLoading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    firstName: "",
    lastName: "",
    email: [],
    platform: [],
    isConnected: null,
    DateFrom: null,
    DateTo: null,
  });
  const [emailValue, setEmailValue] = useState("");
  const { debouncedValue } = useDebounce(filters.name, 500);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState({
    orderByKey: "id",
    orderVal: 0,
  });
  const [paginationResponse, setPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [showFilters, setShowFilter] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [showFilterCounter, setShowFilterCounter] = useState(0);
  const [LeadsData, setLeadsData] = useState([]);
  const [isAddProspectModalOpen, setAddProspectModalOpen] = useState(false);
  const initialProspectForm = {
    firstName: "",
    lastName: "",
    email: "",
    nickname: "",
    birthDate: "",
  };
  const [newProspectForm, setNewProspectForm] = useState(initialProspectForm);

  const platformOptions = [
    {
      id: 0,
      value: "Facebook",
    },
    {
      id: 1,
      value: "Instagram",
    },
    {
      id: 2,
      value: "Shopify",
    },
    {
      id: 3,
      value: "Accounts",
    },
    {
      id: 4,
      value: "IOS",
    },
    {
      id: 5,
      value: "Android",
    },
  ];

  const prospectType = [
    {
      id: 1,
      value: "Call",
    },
    {
      id: 2,
      value: "Email",
    },
    {
      id: 3,
      value: "Visit",
    },
  ];

  const connectionOptions = [
    {
      id: 0,
      name: "No",
    },
    {
      id: 1,
      name: "Yes",
    },
  ];

  const filtersCount =
    (filters.firstName ? 1 : 0) +
    (filters.lastName ? 1 : 0) +
    (filters.email?.length ? filters.email?.length : 0) +
    (filters.platform?.length ? filters.platform?.length : 0) +
    (filters.isConnected !== null ? 1 : 0) +
    (filters.DateFrom ? 1 : 0) +
    (filters.DateTo ? 1 : 0);

  const onOrderBy = newOrder => {
    setOrder(newOrder);
  };

  useEffect(() => {
    if (isOutlookLogin) {
      loadLeadsGeneration();
    }
  }, [isOutlookLogin]);

  const loadLeadsGeneration = useCallback(() => {
    setLoading(true);
    dispatch(
      contactsTypesActions.onGetProspectPaginatedData({
        pagination: {
          pageSize: rowsPerPage,
          pageNo: page,
          orderByKey: order.orderByKey,
          orderByVal: order.orderVal,
        },
        firstName: filters.firstName,
        lastName: filters.lastName,
        email: filters.email,
        contactNo: "",
        platform:
          platformOptions
            .filter(option => filters.platform.includes(option.id))
            .map(option => option.value) || [],
        DateFrom: filters.DateFrom
          ? moment(filters.DateFrom).format("MM/DD/yyyy")
          : null,
        DateTo: filters.DateTo
          ? moment(filters.DateTo).format("MM/DD/yyyy")
          : null,
        search: debouncedValue,
        isConnected:
          filters.isConnected === "No"
            ? false
            : filters.isConnected === "Yes"
              ? true
              : null,
      }),
    )
      .then(prospectResponse => {
        if (prospectResponse?.data?.success) {
          const leadsDataFromApi = prospectResponse?.data?.data?.data || [];
          const pagination = prospectResponse?.data?.data?.pagination;
          if (isOutlookLogin) {
            // Extract emails from leads data
            const emails = leadsDataFromApi
              .map(lead => lead.email)
              .filter(email => email && email.trim() !== "");

            // If there are emails, call the second API
            if (emails.length > 0) {
              // Call the availability API (now it's POST)
              dispatch(dashboardActions.onGetUserTeamAvailability(emails))
                .then(availabilityResponse => {
                  // Combine the data
                  const combinedLeadsData = combineLeadsWithAvailability(
                    leadsDataFromApi,
                    availabilityResponse,
                  );

                  setLeadsData(combinedLeadsData);
                  setPaginationResponse(pagination);
                  setLoading(false);
                })
                .catch(error => {
                  console.error("Error fetching availability:", error);
                  // If second API fails, still show the leads data without availability info
                  setLeadsData(leadsDataFromApi);
                  setPaginationResponse(pagination);
                  setLoading(false);
                });
            } else {
              // No emails to fetch availability for
              setLeadsData(leadsDataFromApi);
              setPaginationResponse(pagination);
              setLoading(false);
            }
          } else {
            setLeadsData(leadsDataFromApi);
            setPaginationResponse(pagination);
            setLoading(false);
          }
        } else {
          setLeadsData([]);
          setPaginationResponse({
            currentCount: 0,
            totalRecords: 0,
          });
          setLoading(false);
        }
      })
      .catch(error => {
        console.error("Error fetching prospects:", error);
        setLeadsData([]);
        setPaginationResponse({
          currentCount: 0,
          totalRecords: 0,
        });
        setLoading(false);
      });
  }, [
    dispatch,
    debouncedValue,
    page,
    rowsPerPage,
    isOutlookLogin,
    order.orderByKey,
    order.orderVal,
  ]);

  // Helper function to combine leads with availability data
  const combineLeadsWithAvailability = (leads, availabilityResponse) => {
    // Create a map for quick lookup by email
    const availabilityMap = new Map();

    // Check if availability response has data
    if (
      availabilityResponse?.data?.success &&
      Array.isArray(availabilityResponse?.data?.data)
    ) {
      availabilityResponse.data.data.forEach(item => {
        // Use email as key to map availability data
        if (item.email) {
          availabilityMap.set(item.email, {
            availability: item.availability,
            chatlink: item.chatlink,
            calllink: item.calllink,
          });
        }
      });
    }

    // Merge availability data into each lead object
    return leads.map(lead => ({
      ...lead,
      availabilityInfo: availabilityMap.get(lead.email) || null, // Add availability info
    }));
  };

  useEffect(() => {
    loadLeadsGeneration();
  }, [debouncedValue, page, rowsPerPage, order]);

  const showFilter = () => {
    window.scroll(0, 0);
    // document.body.classList.add("bodyScroll");
    setIsFilter(true);
  };

  const hideFilter = () => {
    setIsFilter(false);
  };

  const applyFilters = () => {
    setShowFilterCounter(filtersCount);
    hideFilter();
    if (page === 1) {
      setLoading(true);
      dispatch(
        contactsTypesActions.onGetProspectPaginatedData({
          pagination: {
            pageSize: rowsPerPage,
            pageNo: page,
            orderByKey: order.key,
            orderByVal: order.val,
          },
          firstName: filters.firstName,
          lastName: filters.lastName,
          email: filters.email,
          contactNo: "",
          platform:
            platformOptions
              .filter(option => filters.platform.includes(option.id))
              .map(option => option.value) || [],
          isConnected:
            filters.isConnected === "No"
              ? false
              : filters.isConnected === "Yes"
                ? true
                : null,
          DateFrom: filters.DateFrom
            ? moment(filters.DateFrom).format("MM/DD/yyyy")
            : null,
          DateTo: filters.DateTo
            ? moment(filters.DateTo).format("MM/DD/yyyy")
            : null,
          search: debouncedValue,
        }),
      ).then(data => {
        if (data?.data?.success) {
          // setLeadsData(data?.data?.data?.data);
          // setPaginationResponse(data?.data?.data?.pagination);
          const leadsDataFromApi = data?.data?.data?.data || [];
          const pagination = data?.data?.data?.pagination;
          if (isOutlookLogin) {
            // Extract emails from leads data
            const emails = leadsDataFromApi
              .map(lead => lead.email)
              .filter(email => email && email.trim() !== "");

            // If there are emails, call the second API
            if (emails.length > 0) {
              // Call the availability API (now it's POST)
              dispatch(dashboardActions.onGetUserTeamAvailability(emails))
                .then(availabilityResponse => {
                  // Combine the data
                  const combinedLeadsData = combineLeadsWithAvailability(
                    leadsDataFromApi,
                    availabilityResponse,
                  );

                  setLeadsData(combinedLeadsData);
                  setPaginationResponse(pagination);
                  setLoading(false);
                })
                .catch(error => {
                  console.error("Error fetching availability:", error);
                  // If second API fails, still show the leads data without availability info
                  setLeadsData(leadsDataFromApi);
                  setPaginationResponse(pagination);
                  setLoading(false);
                });
            } else {
              // No emails to fetch availability for
              setLeadsData(leadsDataFromApi);
              setPaginationResponse(pagination);
              setLoading(false);
            }
          } else {
            setLeadsData(leadsDataFromApi);
            setPaginationResponse(pagination);
            setLoading(false);
          }
        } else {
          setLeadsData([]);
          setPaginationResponse({
            currentCount: 0,
            totalRecords: 0,
          });
        }
        setLoading(false);
      });
    }
  };

  const onClearButtonPress = () => {
    setLoading(true);
    setPage(1);
    setRowsPerPage(10);
    setShowFilterCounter(0);
    setFilters({
      name: "",
      firstName: "",
      lastName: "",
      email: [],
      platform: [],
      isConnected: null,
      DateFrom: null,
      DateTo: null,
    });
    dispatch(
      contactsTypesActions.onGetProspectPaginatedData({
        pagination: {
          pageSize: 10,
          pageNo: 1,
          orderByKey: "id",
          orderByVal: 0,
        },
        firstName: "",
        lastName: "",
        email: [],
        contactNo: "",
        platform: [],
        isConnected: null,
        search: "",
        DateFrom: null,
        DateTo: null,
      }),
    ).then(data => {
      if (data?.data?.success) {
        setLeadsData(data?.data?.data?.data);
        setPaginationResponse(data?.data?.data?.pagination);
      } else {
        setLeadsData([]);
        setPaginationResponse({
          currentCount: 0,
          totalRecords: 0,
        });
      }
      setLoading(false);
    });
  };

  const loadRoomChat = useCallback(
    chatDetail => {
      setLoading(true);
      dispatch(
        conversationAction.onGetChatDetailsByRoomId({
          roomId: chatDetail?.roomId,
          productId: ConversationConfig.productId,
          hubUserId: chatDetail?.hubUserId,
          take: 10000,
          skip: 0,
        }),
      ).then(res => {
        setLoading(false);
        if (res?.responseCode === 1) {
          setRoomMsgs(res.responseData);
        }
      });
    },
    [dispatch],
  );

  useEffect(() => {
    if (!!selectedRoom) loadRoomChat(selectedRoom);
  }, [loadRoomChat, selectedRoom?.roomId]);

  const headers = [
    { label: "Index", key: "id" },
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Created On", key: "createdOn" },
    { label: "Is Contacted", key: "isConnected" },
  ];

  const downloadCSV = jsonArray => {
    if (!Array.isArray(jsonArray) || jsonArray.length === 0) {
      console.error("Invalid or empty JSON array");
      return;
    }

    const csvRows = [headers.map(x => x.label).join(",")];

    for (const item of jsonArray) {
      const values = headers.map(header => {
        const escapedValue = String(item[header.key] ?? "N/A").replace(
          /"/g,
          '""',
        );
        return `"${escapedValue}"`;
      });
      csvRows.push(values.join(","));
    }

    const csvString = csvRows.join("\n");

    const bom = "\uFEFF";
    const csvWithBom = bom + csvString;

    const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `prospects-${new Date().getMilliseconds()}`;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    setLoading(true);
    dispatch(
      contactsTypesActions.onGetProspectPaginatedData({
        pagination: {
          pageSize: paginationResponse.totalRecords,
          pageNo: 1,
          orderByKey: order.orderByKey,
          orderByVal: order.orderVal,
        },
        firstName: filters.firstName,
        lastName: filters.lastName,
        email: filters.email,
        contactNo: "",
        platform:
          platformOptions
            .filter(option => filters.platform.includes(option.id))
            .map(option => option.value) || [],
        DateFrom: filters.DateFrom
          ? moment(filters.DateFrom).format("MM/DD/yyyy")
          : null,
        DateTo: filters.DateTo
          ? moment(filters.DateTo).format("MM/DD/yyyy")
          : null,
        search: debouncedValue,
        isConnected:
          filters.isConnected === "No"
            ? false
            : filters.isConnected === "Yes"
              ? true
              : null,
      }),
    ).then(data => {
      if (data?.data && data?.data.success) {
        const dataForExport = data?.data?.data?.data.map((item, index) => ({
          id: index + 1,
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          createdOn: item.createdOn
            ? moment(item.createdOn).format("DD-MM-YYYY")
            : "",
          isConnected: item.isContacted ? "Yes" : "No",
        }));
        downloadCSV(dataForExport);
      }
      setLoading(false);
    });
  };

  const resetProspectFormState = () => {
    setNewProspectForm(initialProspectForm);
  };

  const handleOpenAddProspectModal = () => {
    // setAddProspectModalOpen(true);
    handleAddFullDetails();
  };

  const handleCloseAddProspectModal = () => {
    setAddProspectModalOpen(false);
    resetProspectFormState();
  };

  const handleProspectFieldChange = (field, value) => {
    setNewProspectForm(prevForm => ({
      ...prevForm,
      [field]: value,
    }));
  };

  const handleAddFullDetails = () => {
    const draftPayload = {
      personalInfo: {
        firstName: newProspectForm.firstName,
        lastName: newProspectForm.lastName,
        nickname: newProspectForm.nickname,
      },
      contactInfo: {
        email: newProspectForm.email,
      },
      jobDetails: {
        title: newProspectForm.title,
      },
      accountDetails: {
        companyName: newProspectForm.company,
      },
    };
    setAddProspectModalOpen(false);
    history.push("/new-prospect-generation", {
      prospectDraft: draftPayload,
    });
    resetProspectFormState();
  };

  const handleQuickAddProspect = () => {
    const prospectPayload = {
      firstName: newProspectForm?.firstName,
      lastName: newProspectForm?.lastName,
      email: newProspectForm?.email,
      contactNo: "",
      nickName: newProspectForm?.nickname,
      dob: newProspectForm?.birthDate,
    };
    setLoading(true);
    dispatch(contactsTypesActions.onAddProspect(prospectPayload)).then(data => {
      setLoading(false);
      if (data?.data?.success) {
        handleCloseAddProspectModal();
        loadLeadsGeneration();
      } else {
        toast.error(data?.data?.message);
      }
    });
  };

  const onSendMessage = async ({
    messageContent,
    clearContent,
    fileName,
    uploadFile,
  }) => {};

  return (
    <Dashbard>
      <div className='body-content tableInnerWrapper'>
        {isLoading ? <Loader /> : null}
        <div className='contentHeading launchBtn'>
          <h1>All Prospects</h1>
          <Button
            color='primary'
            variant='contained'
            startIcon={<AddIcon />}
            onClick={handleOpenAddProspectModal}>
            Add Prospect
          </Button>
        </div>
        <div className='gridBody contentBody '>
          <GridSearchFilter
            isFilterAdded={true}
            setFilters={setFilters}
            filters={filters}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
            title={"All Prospect Filter"}
            isFilter={isFilter}
            showFilter={showFilter}
            hideFilter={hideFilter}
            applyFilters={applyFilters}
            showFilterCounter={showFilterCounter}>
            <Accordion
              defaultExpanded
              id='end-user-filter-expandable'
              TransitionProps={{ unmountOnExit: true }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>
                  <span>Active Filter(s)</span>
                  <span>
                    <Button
                      className='filterClearBtn filterClearBtnStyle'
                      variant='outlined'
                      onClick={() => {
                        hideFilter();
                        onClearButtonPress();
                      }}>
                      Clear
                    </Button>
                  </span>
                </Typography>
              </AccordionSummary>
              <div style={{ marginBottom: "10px" }}>
                {filtersCount <= 0 && (
                  <div className={`filtersChips`}>No Active Filter(s)</div>
                )}
              </div>

              <SelectedDateChip
                startDate={filters.DateFrom}
                endDate={filters.DateTo}
                setStartDate={date => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    DateFrom: date,
                  }));
                }}
                setEndDate={date => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    DateTo: date,
                  }));
                }}
                chipLabel={"Creation Date"}
              />
              {filters.firstName?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='First Name'
                    chipValue={filters.firstName}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        firstName: "",
                      }));
                    }}
                  />
                )}
              {filters.lastName?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='Last Name'
                    chipValue={filters.lastName}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        lastName: "",
                      }));
                    }}
                  />
                )}

              {filters.email?.map(email => {
                // filtersIndex = filtersIndex + 1;
                return (
                  (filtersIndex <= filtersLimit ||
                    (filtersIndex > filtersLimit && showFilters)) && (
                    <ChipItem
                      chipLabel='Email'
                      chipValue={email}
                      onDelete={() =>
                        setFilters(prevFilters => ({
                          ...prevFilters,
                          email: prevFilters.email.filter(e => e !== email),
                        }))
                      }
                    />
                  )
                );
              })}

              {filters.isConnected?.length > 0 &&
                (filtersIndex <= filtersLimit ||
                  (filtersIndex > filtersLimit && showFilters)) && (
                  <ChipItem
                    chipLabel='Contacted'
                    chipValue={filters.isConnected}
                    onDelete={() => {
                      setFilters(prevFilters => ({
                        ...prevFilters,
                        isConnected: null,
                      }));
                    }}
                  />
                )}

              <div
                style={{
                  textAlign: "right",
                }}>
                {filtersCount > filtersLimit && (
                  <IconButton
                    color={"primary"}
                    onClick={() => setShowFilter(!showFilters)}>
                    <MoreHoriz />
                  </IconButton>
                )}
              </div>
            </Accordion>
            <div className='userDetailsSearchField inputWrapper filterSelect'>
              <div style={{ marginBottom: "10px" }}>
                <h4>Prospect Creation Date</h4>
                <FilterCreationDate
                  StartDate={filters.DateFrom}
                  setStartDate={date => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      DateFrom: date,
                    }));
                  }}
                  EndDate={filters.DateTo}
                  setEndDate={date => {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      DateTo: date,
                    }));
                  }}
                />
              </div>
              <InputField
                id='FirstName'
                name='FirstName'
                placeholder={"First Name"}
                value={filters.firstName}
                onChange={({ target }) =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    firstName: target.value,
                  }))
                }
              />
              <InputField
                id='LastName'
                name='LastName'
                placeholder={"Last Name"}
                value={filters.lastName}
                onChange={({ target }) =>
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    lastName: target.value,
                  }))
                }
              />
              <InputField
                id='Email'
                name='Email'
                placeholder={"Email"}
                value={emailValue}
                onChange={({ target }) => setEmailValue(target.value)}
                onKeyDown={({ key }) => {
                  if (key === "Enter") {
                    setFilters(prevFilters => ({
                      ...prevFilters,
                      email: [...prevFilters.email, emailValue],
                    }));
                    setEmailValue("");
                  }
                }}
              />

              <AutoComplete
                value={
                  connectionOptions.filter(x =>
                    filters?.isConnected?.includes(x.name),
                  )?.id ?? null
                }
                onChange={(event, value) => {
                  setFilters(prevFilters => ({
                    ...prevFilters,
                    isConnected: value.name,
                  }));
                }}
                id='leads-filters'
                options={connectionOptions}
                getOptionLabel={option => option?.name || ""}
                placeholder={"Is Contacted"}
              />
            </div>
          </GridSearchFilter>
          <ProspectGenerationGrid
            onOrderBy={onOrderBy}
            order={order}
            LeadsData={LeadsData}
            roomMsgs={roomMsgs}
            setRoomMsgs={setRoomMsgs}
            selectedRoom={selectedRoom}
            setSelectedRoom={setSelectedRoom}
            leadData={leadData}
            setLeadData={setLeadData}
            onSendMessage={onSendMessage}
            isLoading={isLoading}
            setLoading={setLoading}
            onClearButtonPress={onClearButtonPress}
            loadLeadsGeneration={loadLeadsGeneration}
            handleExport={handleExport}
          />

          <Pagination
            recordCount={paginationResponse?.totalRecords}
            page={page - 1}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
          <AddProspectModal
            open={isAddProspectModalOpen}
            onClose={handleCloseAddProspectModal}
            onAddFullDetails={handleAddFullDetails}
            onAdd={handleQuickAddProspect}
            values={newProspectForm}
            onFieldChange={handleProspectFieldChange}
          />
        </div>
      </div>
    </Dashbard>
  );
};

export default ProspectGeneration;
